import { useFormik } from 'formik';
import { Link } from 'react-router-dom';
import { handleResetPassword } from '../../../api/auth';
import ErrorMsg, { ErrorApiMsg, SuccessApiMsg } from './error-msg';
import { recuperarASenhaSchema } from './validation-schema';
import React, { useState } from 'react';

const EsqueciASenhaForm = () => {

  const [apiErrors, setApiErrors] = useState(null);
  const [apiSuccess, setApiSuccess] = useState(null);
  
  // esqueci a senha form
  const handleOnSubmit = (values, { resetForm }) => {
    
    setApiErrors(null);
    setApiSuccess(null);

    handleResetPassword(values).then(function(result) {
      setApiSuccess('Acesse seu e-mail para confirmar sua solicitação de recuperação de senha.');
      resetForm();
    });
    
  }

  // use formik
  const { handleChange, handleSubmit, handleBlur, errors, values, touched } = useFormik({
    initialValues: { email: '' },
    validationSchema: recuperarASenhaSchema,
    onSubmit: handleOnSubmit,
  });

  return (
    <form onSubmit={handleSubmit}>
      
      <div className="sign__input-wrapper mb-25">
        <h5>Seu email</h5>
        <div className="sign__input">
          <input value={values.email} onChange={handleChange} onBlur={handleBlur} 
          type="email" placeholder="Seu e-mail" name='email' />
          <i className="fal fa-envelope"></i>
        </div>
        {touched.email && <ErrorMsg error={errors.email} />}
      </div>

      <button className="e-btn w-100"> <span></span> Recuperar senha</button>

      {apiErrors && <ErrorApiMsg error={apiErrors} />}

      {apiSuccess && <SuccessApiMsg msg={apiSuccess} />}
     
    </form>
  );
};

export default EsqueciASenhaForm;